module.exports = __webpack_public_path__ + "static/img/map.6eb705d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/images/map.png
// module id = wda7
// module chunks = 1